import { Stack } from "flicket-ui";
import { useContext } from "react";
import { OrderSummaryContext } from "~features/single-page-checkout/components/OrderSummary/OrderSummaryContext";
import { SinglePageCheckoutListItem } from "~features/single-page-checkout/components/OrderSummary/ListItem";

export const ExpressCheckoutSummary = ({
  totalToBePaid,
}: {
  totalToBePaid: number;
}) => {
  const { isLoading } = useContext(OrderSummaryContext);

  return (
    <Stack direction={"vertical"} gap={1}>
      <SinglePageCheckoutListItem
        title={"Total"}
        price={totalToBePaid}
        variant="header.S"
        isLoading={isLoading}
      />
    </Stack>
  );
};
